import { Controller } from 'stimulus';
import { updateDropdownMenuPositionInExtendedFilters } from "../packs/filter_helpers";

export default class extends Controller {
  static targets = ['template', "forms", "dropdownButton", "buttonText", "checkboxList", "searchInput", "loadingSpinner", "selectedSection", "unselectedSection", "selectedToggleIcon", "selectedSectionTitle"];
  static values = { label: String };

  initialize() {
    if(window.location.pathname.includes("/manage_attributes")){
      let attribute_key_count = $(".key-form").length
      if(attribute_key_count == 0){
        var content = this.templateTarget.innerHTML.replace(/new_record/g, attribute_key_count + 1);
        $(this.formsTarget).append(content)
      }
    }
  }

  connect() {
    this.usersLoaded = false; // Track if users have been loaded
    this.isLoading = false;
    this.searchTimeout = null;
    this.selectedUserIds = new Set(); // Track selected user IDs
    this.selectedSectionExpanded = false; // Track if selected section is expanded
    this.initializeSelectedUsers();
  }

  initializeSelectedUsers() {
    // Get initially selected IDs from data attribute
    const selectedIds = this.element.dataset.selectedIds;
    if (selectedIds) {
      selectedIds.split(',').forEach(id => {
        if (id.trim()) {
          this.selectedUserIds.add(parseInt(id.trim()));
        }
      });
    }
    this.updateButtonText();
  }

  loadUserDropdown(event) {
    // Only load users if they haven't been loaded yet
    if (!this.usersLoaded && this.hasLoadingSpinnerTarget) {
      this.usersLoaded = true;
      this.loadUsers(''); // Load initial 100 users
      this.populateSelectedSection(); // Show any pre-selected users in selected section
    }
  }

  populateSelectedSection() {
    // If we have selected users but selected section is empty, we need to fetch them
    if (this.selectedUserIds.size > 0 && this.hasSelectedSectionTarget) {
      const selectedIdsArray = Array.from(this.selectedUserIds);
      
      // Make a request to get the selected users' details
      const params = new URLSearchParams({
        field_name: this.element.dataset.fieldName,
        field_prefix: this.element.dataset.fieldPrefix,
        selected_ids: selectedIdsArray.join(','),
        selected_only: 'true' // New parameter to get only selected users
      });
      
      Rails.ajax({
        type: 'GET',
        url: `/projects/user_dropdown_list?${params}`,
        dataType: 'json',
        success: (response) => {
          // Parse the response and add selected users to selected section
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = response.entries;
          const userItems = tempDiv.querySelectorAll('li.checkbox-li');
          
          userItems.forEach(item => {
            const checkbox = item.querySelector('input[type="checkbox"]');
            const userId = parseInt(checkbox.value);
            
            if (this.selectedUserIds.has(userId)) {
              checkbox.checked = true;
              if (this.hasSelectedSectionTarget) {
                this.selectedSectionTarget.appendChild(item.cloneNode(true));
              }
            }
          });
        },
        error: (xhr, status, error) => {
          console.error('Error loading selected users:', error);
        }
      });
    }
  }

  loadUsers(search = '') {
    if (this.isLoading) return;
    
    this.isLoading = true;
    
    const fieldName = this.element.dataset.fieldName;
    const fieldPrefix = this.element.dataset.fieldPrefix;
    const selectedIds = this.element.dataset.selectedIds;
    
    const params = new URLSearchParams({
      field_name: fieldName,
      field_prefix: fieldPrefix,
      selected_ids: selectedIds,
      search: search
    });
    
    if (this.hasLoadingSpinnerTarget) {
      this.loadingSpinnerTarget.style.display = 'block';
    }
    
    Rails.ajax({
      type: 'GET',
      url: `/projects/user_dropdown_list?${params}`,
      dataType: 'json',
      success: (response) => {
        this.updateDropdownSections(response.entries);
        this.updateButtonText();
      },
      error: (xhr, status, error) => {
        this.checkboxListTarget.innerHTML = '<p class="p-3 mb-0 text-danger">Error loading users</p>';
        console.error('Error loading users:', error);
      },
      complete: () => {
        this.isLoading = false;
        if (this.hasLoadingSpinnerTarget) {
          this.loadingSpinnerTarget.style.display = 'none';
        }
      }
    });
  }


  addKeyFilter(event) {
    if (event.target.checked) {
      let url = `/projects/add_key_filter?`
      let params = new URLSearchParams()
      let key_id = event.target.dataset.id;
      let filter_type = event.target.dataset.type;
      params.set("key_id", key_id);
      params.set("filter_type", filter_type);

      let class_name = '.' + event.target.dataset.type + '-' + event.target.dataset.id;
      let container = $(`#${event.target.dataset.type}_dynamic_filters`)

      Rails.ajax({
        type: 'GET',
        url: url + params,
        dataType: 'json',
        success: (response) => {
          container.append(response)
          updateDropdownMenuPositionInExtendedFilters();
        }
      })
    } else {

// TODO: integrate these updates into the code properly
//      let class_name = '.' + event.target.dataset.type + '-' + event.target.dataset.id;
//      $(class_name).find('input[type=checkbox]:checked').removeAttr('checked');
//      this.searchKeyFilter();
//      $(class_name).remove();

      let removeElement = '.' + event.target.dataset.type + '-' + event.target.dataset.id
      var reload = false;
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);
      let param_name = `${event.target.dataset.type}[${event.target.dataset.id}]`

      if(event.target.dataset.dataType == "date" || event.target.dataset.dataType == "number"){
        if(params.get(`${param_name}[from]`) || params.get(`${param_name}[to]`)) reload = true;
        params.delete(`${param_name}[from]`)
        params.delete(`${param_name}[to]`)
      } else {
        if(params.get(`${param_name}`)) reload = true;
        params.delete(`${param_name}`)
      }

      if(reload) window.location.href = window.location.href.split('?')[0] + '?' + params.toString()
      $(removeElement).remove();

    }
  }

  searchKeyAttributes(event) {
    var search = $(event.target).val().trim().toLowerCase();
    $(".dynamic-add-checkbox").each(function () {
      if ($(this).text().toLowerCase().indexOf(search) < 0){
        $(this).hide()
      } else {
        $(this).show()
        $(this).children('ul')?.first()?.addClass('show')
      }
    })
  }

  renderNewKeyForm(event) {
    event.preventDefault();
    
    let current_max_position = $(".key-form").length
    let next_positon = Number(current_max_position) + 1

    var content = this.templateTarget.innerHTML.replace(/new_record/g, next_positon);
    $(this.formsTarget).append(content)
  }

  removeAttributeKeyField(event) {
    let attribute_key_id = $(event.target).parents(".remove-button-container").data("key-id");

    if(attribute_key_id){
      Rails.ajax({
        type: 'GET',
        url: `/attribute_keys/${attribute_key_id}/has_attribute_values`,
        dataType: 'json',
        success: (response) => {
          if(response.has_values){
            if (confirm('This key has associated values, if you delete the key all the associated data will be lost.')){
              $(event.target).parents(".key-form").find(".destroy-field").val("1")
              $(event.target).parents(".key-form").hide();
            }
          } else {
            $(event.target).parents(".key-form").find(".destroy-field").val("1")
            $(event.target).parents(".key-form").hide();
          }
        }
      })
    } else {
      $(event.target).parents(".key-form").find(".destroy-field").val("1")
      $(event.target).parents(".key-form").hide();
    }
    
  }

  updateDropdownSections(entriesHtml) {
    // Create a temporary container to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = entriesHtml;
    const userItems = tempDiv.querySelectorAll('li.checkbox-li');
    
    // Clear unselected section and populate with new results
    if (this.hasUnselectedSectionTarget) {
      this.unselectedSectionTarget.innerHTML = '';
      
      userItems.forEach(item => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        const userId = parseInt(checkbox.value);
        
        // Only add to unselected section if not already selected
        if (!this.selectedUserIds.has(userId)) {
          checkbox.checked = false;
          this.unselectedSectionTarget.appendChild(item.cloneNode(true));
        }
      });
    }
  }

  handleCheckboxChange(event) {
    const checkbox = event.target;
    const userId = parseInt(checkbox.value);
    const listItem = checkbox.closest('li.checkbox-li');
    
    if (checkbox.checked) {
      this.selectedUserIds.add(userId);
      this.moveToSelectedSection(listItem);
    } else {
      this.selectedUserIds.delete(userId);
      this.moveToUnselectedSection(listItem);
    }
    
    this.updateButtonText();
    this.updateHiddenInputs();
  }

  moveToSelectedSection(listItem) {
    if (this.hasSelectedSectionTarget) {
      // Update checkbox state
      const checkbox = listItem.querySelector('input[type="checkbox"]');
      checkbox.checked = true;
      
      // Move to selected section
      this.selectedSectionTarget.appendChild(listItem);
    }
  }

  moveToUnselectedSection(listItem) {
    if (this.hasUnselectedSectionTarget) {
      // Update checkbox state
      const checkbox = listItem.querySelector('input[type="checkbox"]');
      checkbox.checked = false;
      
      // Move to unselected section
      this.unselectedSectionTarget.appendChild(listItem);
    }
  }

  filterUsers(event) {
    const searchTerm = event.target.value.trim();
    
    // Auto-collapse selected section when searching to prioritize results
    if (searchTerm) {
      this.autoCollapseOnSearch();
    }
    
    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    
    // Debounce search to avoid too many requests
    this.searchTimeout = setTimeout(() => {
      this.loadUsers(searchTerm);
    }, 300);
  }

  updateButtonText() {
    if (this.hasButtonTextTarget) {
      const count = this.selectedUserIds.size;
      
      const currentText = this.buttonTextTarget.textContent;
      const labelName = currentText.includes('Users') ? 'Users' : 
                       currentText.includes('Admins') ? 'Admins' : 'Items';
      
      if (count === 0) {
        this.buttonTextTarget.textContent = `Select ${labelName}`;
      } else {
        this.buttonTextTarget.textContent = `${count} Selected`;
      }
    }
    
    // Update selected section title
    if (this.hasSelectedSectionTitleTarget) {
      const count = this.selectedUserIds.size;
      this.selectedSectionTitleTarget.textContent = `Selected Users (${count})`;
    }
  }

  toggleSelectedSection() {
    if (this.hasSelectedSectionTarget && this.hasSelectedToggleIconTarget) {
      this.selectedSectionExpanded = !this.selectedSectionExpanded;
      
      if (this.selectedSectionExpanded) {
        this.selectedSectionTarget.style.display = 'block';
        this.selectedToggleIconTarget.className = 'fas fa-chevron-up';
      } else {
        this.selectedSectionTarget.style.display = 'none';
        this.selectedToggleIconTarget.className = 'fas fa-chevron-down';
      }
    }
  }

  // Auto-collapse selected section when searching to prioritize results
  autoCollapseOnSearch() {
    if (this.selectedSectionExpanded && this.selectedUserIds.size > 3) {
      this.selectedSectionExpanded = false;
      if (this.hasSelectedSectionTarget) {
        this.selectedSectionTarget.style.display = 'none';
      }
      if (this.hasSelectedToggleIconTarget) {
        this.selectedToggleIconTarget.className = 'fas fa-chevron-down';
      }
    }
  }

  updateHiddenInputs() {
    // Update hidden inputs with selected user IDs for form submission
    const fieldName = this.element.dataset.fieldName;
    if (!fieldName) return;
    
    // Remove existing hidden inputs for this field
    const existingInputs = this.element.querySelectorAll(`input[name="${fieldName}[]"]`);
    existingInputs.forEach(input => {
      if (input.type === 'hidden') {
        input.remove();
      }
    });
    
    // Add hidden inputs for selected users
    this.selectedUserIds.forEach(userId => {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = `${fieldName}[]`;
      hiddenInput.value = userId;
      this.element.appendChild(hiddenInput);
    });
  }
}